export { Accordion } from "@mantine/core";
export type { AccordionProps } from "@mantine/core";
export { getAccordionOverrides } from "./Accordion.styled";
